import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryTradingStrategyContractConfig extends BaseWasmQuery {
    toPayload() {
        const payload = toBase64({
            config: {},
        });
        return payload;
    }
}
